<template>
  <div>
    <transition name="fade">
      <div
        class="alert fw-medium mt-3"
        :class="{
          'bg-soft-success': response.success,
        }"
        role="alert"
        v-if="response.success"
      >
        <i class="uil uil-check-circle fs-5 align-middle me-1"></i>
        {{ response.success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        class="alert fw-medium mt-3"
        :class="{
          'bg-soft-danger': response.error,
        }"
        role="alert"
        v-if="response.error"
      >
        <i class="uil uil-exclamation-octagon fs-5 align-middle me-1"></i>
        {{ response.error }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ProfileResponse",
  props: {
    response: {
      type: String,
      required: true,
    },
  },
};
</script>